export const zps_ea_war = process.env.REACT_APP_ZPS_EA_WAR;
console.log(`zps_ea_war: ${zps_ea_war}`);
export const zps_ms_ea_war = process.env.REACT_APP_ZPS_MS_EA_WAR;
console.log(`zps_ms_ea_war: ${zps_ms_ea_war}`);
export const zps_auth = process.env.REACT_APP_ZPS_AUTH;
console.log(`zps_auth: ${zps_auth}`);
export const zps_wp = process.env.REACT_APP_ZPS_WP;
console.log(`zps_wp: ${zps_wp}`);

export interface StatusOper {
  code: number;
  message: string;
}

export const STATUS_OPER_AUTH_ERRORS = [
  2, // STATOP_AUTHENTICATION_FAILED
  3, // STATOP_AUTHENTICATION_NO_USER
  4, // STATOP_AUTHENTICATION_WRONG_PASS
  5, // STATOP_AUTHENTICATION_WITHOUT_PERM
  6 // STATOP_AUTHENTICATION_TIMEOUT
];

export interface ApiResponse {
  statusOper: StatusOper;
}

export interface Page<T> {
  content: T[];
  pageable: {
    offset: number;
    pageSize: number;
    pageNumber: number;
  };
  last: boolean;
  totalPages: number;
  totalElements: number;
  first: boolean;
  numberOfElements: number;
}

export interface GetReportResponse extends ApiResponse {
  report: string; //Base64 data
  format: string;
  name: string;
  mime: string;
  type: string;
}
